import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@tess-core/shared';

@Component({
  selector: 'tess-navigation-actions',
  imports: [IconComponent],
  templateUrl: './navigation-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationActionsComponent {
  readonly itemStyles =
    'cursor-pointer text-[10px] transition-colors p-1.5 rounded-sm bg-white/10 text-light-200 hover:bg-white/20 hover:text-main-white';
}
